import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./autocomplete.script";
export function RuiAutocompleteInput({
  placeholder,
  class: className,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("input", {
    ...props,
    type: "search",
    "data-autocomplete-input": true,
    class: cx("rui-autocomplete__input", className),
    placeholder,
    disabled,
    autocomplete: "off"
  });
}
export function RuiAutocompleteCollection({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-autocomplete-collection": true,
    class: cx("rui-autocomplete__collection", className),
    children
  });
}
export function RuiAutocompleteEmpty({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-autocomplete-empty": true,
    class: cx("rui-autocomplete__empty", className),
    children
  });
}
function AutocompleteShell({
  children
}) {
  return /* @__PURE__ */jsx("div", {
    class: "rui-autocomplete",
    "data-ref": "root",
    children
  });
}
export function RuiAutocomplete({
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-autocomplete", {
    ...props,
    children: /* @__PURE__ */jsx(AutocompleteShell, {
      children
    })
  });
}